<template>
  <form
    :class="$style['form-search']"
    role="search"
    @submit.prevent="$emit('submit')">
    <FormInput
      ref="input"
      :is-hidden="isHidden"
      :model-value="modelValue"
      no-border
      type="search"
      :loading="loading"
      :class="$style['form-input--search']"
      :placeholder="randomSearchPlaceholder ? randomSearchPlaceholder : $t('general/search-placeholder-1')"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      @focus="$emit('focus')"
      @close="$emit('close')" />
  </form>
</template>
<script setup>
const randomSearchPlaceholder = useState('searchPlaceholder')

if (!import.meta.client && !randomSearchPlaceholder.value) {
  randomSearchPlaceholder.value = $t(`general/search-placeholder-${Math.ceil(Math.random() * 5)}`)
}

defineEmits(['update:modelValue', 'focus', 'submit', 'close', 'enter'])
defineProps({
  modelValue: {
    type: String,
    default: null
  },
  loading: {
    type: Boolean,
    default: true
  },
  isHidden: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" module>
.form-search {
  width: 100%;
  position: relative;
  z-index: calc(var(--z-index-modal) + 1);
}

.form-input {
  &--search {
    input {
      padding-block: 2px;
    }
  }
}
</style>
